export class SettingsStandingOrdersEntity {
  constructor() {
    this.standingOrderName = null;
    this.standingOrderLastKnownDate = null;
    this.standingOrderFrequency = null;
    this.standingOrderLastKnownAmount = null;
  }
  getSettingsStandingOrderEntity() {
    return this;
  }
}

export default SettingsStandingOrdersEntity;
